import { cn } from "@/lib/utils";
import type { SVGProps } from "react";

/**
 * OLX-style mark (o, l, x) — matches Lucide usage: pass `className="h-4 w-4"` or `h-3.5 w-3.5` on the products listing.
 * Stroke uses `currentColor` so it matches the parent button (e.g. emerald text on OLX post).
 */
export function OlxIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      {/* Thickness: ~same visual weight as Lucide at h-4 w-4 (24 viewBox / stroke 2). */}
      <g strokeWidth={3.2}>
        <circle cx="13.325" cy="23.8942" r="8.825" fill="none" />
        <path d="m32.2648,18.3824l11.2352,11.2352" fill="none" />
        <path d="m32.2648,29.6176l11.2352-11.2352" fill="none" />
        <path d="m27.3016,12.7648v22.4705" fill="none" />
      </g>
    </svg>
  );
}
